export * from './data-processing-bottom';
export * from './data-processing-main';
export * from './data-processing-preamble';
export * from './suppliers';
export * from './toms';

import './data-processing.scss';
